import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/search.svg'
import _imports_1 from '../../assets/img/icons/add-circle.svg'
import _imports_2 from '../../assets/img/icons/tick-circle.svg'


const _hoisted_1 = { class: "main-content bg_gray d-flex flex-column transition overflow-hidden" }
const _hoisted_2 = { class: "row gx-0 mb-30" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_MainSidebar = _resolveComponent("MainSidebar")!
  const _component_BreadcrumbMenu = _resolveComponent("BreadcrumbMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CategoryList = _resolveComponent("CategoryList")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CreateCategoryModal = _resolveComponent("CreateCategoryModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_MainSidebar),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BreadcrumbMenu, { pageTitle: "Category" }),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-md-6\" data-v-531b6f45><div class=\"filter-left d-flex align-items-center flex-wrap\" data-v-531b6f45><form action=\"#\" class=\"search-area position-relative w-sm-100\" data-v-531b6f45><input type=\"text\" placeholder=\"Search On This Table\" class=\"w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white\" data-v-531b6f45><button type=\"submit\" class=\"bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2\" data-v-531b6f45><img src=\"" + _imports_0 + "\" alt=\"Image\" data-v-531b6f45></button></form></div></div>", 1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/create-warehouse",
              class: "btn style-one",
              "data-bs-toggle": "modal",
              "data-bs-target": "#createModal"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode(" Create Category "),
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Image"
                }, null, -1)
              ])),
              _: 1,
              __: [0]
            })
          ])
        ])
      ]),
      _createVNode(_component_CategoryList),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _createVNode(_component_MainFooter)
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"delete-popup offcanvas offcanvas-end border-0\" tabindex=\"-1\" id=\"deletePopup\" data-v-531b6f45><div class=\"offcanvas-body p-0\" data-v-531b6f45><div class=\"delete-success\" data-v-531b6f45><img src=\"" + _imports_2 + "\" alt=\"Image\" data-v-531b6f45><span class=\"text-white fw-medium\" data-v-531b6f45> Your product is deleted from the list. </span></div></div></div>", 1)),
    _createVNode(_component_CreateCategoryModal)
  ], 64))
}